export enum EventProgress {
  ACTIVE_EVENTS = 'active',
  PAST_EVENTS = 'past',
}
